import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import i18n from 'i18next';

import useShipmentProductQtyUomList from '../../../redux/hooks/useShipmentProductQtyUomList';
import { routeFileSelector } from '../../../utilz/i18n';
import FormSelectBox from '../Inputs/FormSelectBox';

const ProductUnitUomSelector = ({
  placeholder = i18n.t('translation:default.fields.unitOfMeasurement.placeholder'),
  label = i18n.t('translation:default.fields.unitOfMeasurement.label'),
  rules = [],
  name,
  editMode,
  onChange,
  tooltip,
  isDefault = false,
  tabIndex,
  disableValidation = false,
  margin = 'mb-0',
  labelClass = '',
  shouldUseNativeSelect = false,
}) => {
  const [options, setOptions] = useState([]);
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);
  const uomList = useShipmentProductQtyUomList();

  useEffect(() => {
    if (uomList?.length >= 0) {
      const options = uomList.map((row) => ({
        label: row.codeDesc,
        value: row.codeId.trim(),
      }));
      setOptions(options);
    } else {
      setOptions([]);
    }
  }, [uomList]);

  return (
    <FormSelectBox
      loading={uomList === undefined}
      labelClass={labelClass}
      options={
        isDefault === true ? [{ label: t('translation:default.buttons.select'), value: '' }, ...options] : options
      }
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      editMode={editMode}
      onChange={onChange}
      tooltip={tooltip}
      tabIndex={tabIndex}
      disableValidation={disableValidation}
      shouldUseNativeSelect={shouldUseNativeSelect}
    />
  );
};

export default ProductUnitUomSelector;
